import { CollectionViewer, DataSource } from "@angular/cdk/collections";
import { MatPaginator, MatSort } from "@angular/material"
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { LoadPageAction } from "../../pillar/common/actions/LoadPageAction";
import { SearchComponent } from "../../pillar/search/components/search.component";
import { Subject } from "rxjs/Subject";

export class StoreDataSource<TModel> implements DataSource<TModel> {

  constructor(
    private destroyed$: Subject<boolean>,
    public paginator: MatPaginator,
    private store: Store<any>,
    private pagedItems$: Observable<TModel[]>,
    private totalCount$: Observable<number>,
    public loading$: Observable<boolean>,
    private actionFactory: (paginator: MatPaginator, sort: MatSort, search: SearchComponent) => LoadPageAction,
    public sort?: MatSort | null,
    public search?: SearchComponent | null) {
    if (paginator) {
      paginator.page.takeUntil(destroyed$)
        .subscribe(() => {
          this.sendPageEvent();
        });

      totalCount$.takeUntil(destroyed$).subscribe(value => {
        this.paginator.length = value;
        if (this.paginator.pageIndex > 0) {
          const lastPageIndex = Math.ceil(this.paginator.length / this.paginator.pageSize) - 1 || 0;
          this.paginator.pageIndex = Math.min(this.paginator.pageIndex, lastPageIndex);
        }
      });
    }
    if (sort) {
      sort.sortChange.takeUntil(destroyed$)
        .subscribe(() => {
          this.sendPageEvent();
        });
    }
    if (search) {
      search
        .searchControl
        .valueChanges
        .debounceTime(500)
        .takeUntil(destroyed$)
        .subscribe(() => {
          this.sendPageEvent();
        });
    }
  }

  connect(collectionViewer: CollectionViewer): Observable<TModel[]> {
    this.sendPageEvent();
    return this.pagedItems$;
  }

  disconnect(collectionViewer: CollectionViewer): void {
    if (this.paginator) {
      this.paginator.page.unsubscribe();
    }
  }

  private sendPageEvent(): void {
    this.store.dispatch(this.actionFactory(this.paginator, this.sort, this.search));
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/StoreDataSource.ts